export enum resourceType {
  ROOM = 1,
  ADVANCED_ROOM,
  BOOTH,
  VIEWER_HOURS,
  CLOUD_STORAGE,
  SUPPORT_HOURS,
  PRE_EVENT_SUPPORT,
  SETUP,
  DESIGN
}
export enum resourcePaymentCycle {
  ONE_TIME = 1,
  MONTHLY,
  YEARLY
}
export enum resourceUnit {
  ROOM = 1,
  HOUR,
  GB,
  SESSION,
}
